import { findParentNode, mergeAttributes, Node } from '@tiptap/core';
import {
	getAttrs,
	renderHTMLAttrs,
	SIGNATURE_VALUE_ATTRIBUTE,
	TEMPLATE_VALUE_ATTRIBUTE,
} from './TemplateValue';
import { addBorderAttributes, buildTableStyle } from './data';
import { parseStyleString } from '@/utils/emailHelper';

const CustomDiv = Node.create({
	name: 'div',
	content: 'block+',
	marks: '_',
	group: 'block',
	draggable: true,

	addOptions() {
		return {
			HTMLAttributes: {},
		};
	},

	addAttributes() {
		return {
			...TEMPLATE_VALUE_ATTRIBUTE,
			...SIGNATURE_VALUE_ATTRIBUTE,
			...addBorderAttributes({
				defaultStyle: '',
				defaultBackgroundColour: '',
				defaultBorders: {
					top: false,
					bottom: false,
					left: false,
					right: false,
				},
			}),
			height: { default: null },
			width: { default: null },
			class: {
				default: null,
			},
			style: {
				default: null,
				parseHTML: (element) => element.getAttribute('style'),
				renderHTML: (attributes) => {
					if (!attributes.style) return {};
					return { style: attributes.style };
				},
			},
		};
	},
	parseHTML() {
		return [
			{
				tag: 'div',
				getAttrs: (element) => {
					const base = getAttrs(element);
					const style = element.getAttribute('style');
					const className = element.getAttribute('class');
					const styleObj = parseStyleString(style ?? '');

					return {
						...base,
						[SIGNATURE_VALUE_ATTRIBUTE]:
							element.getAttribute(SIGNATURE_VALUE_ATTRIBUTE),
						height: styleObj.height,
						width: styleObj.width,
						class: className,
						style,
					};
				},
			},
		];
	},
	renderHTML({ HTMLAttributes }) {
		const style = buildTableStyle(HTMLAttributes, '');

		const { style: _oldStyle, ...cleanAttrs } = HTMLAttributes;
		const { height, width } = HTMLAttributes;

		const newStyle = [height && `height:${height};`, width && `width:${width};`]
			.filter(Boolean)
			.join('');
		const attrs = renderHTMLAttrs({
			HTMLAttributes: {
				...cleanAttrs,
				style: `${style}${newStyle}`,
			},
			editor: this.editor,
		});
		return ['div', mergeAttributes(attrs), 0];
	},
	addCommands() {
		return {
			...this.parent?.(),
			setDivBorders:
				({ top, bottom, left, right }) =>
				({ state, tr, dispatch }) => {
					const { selection } = state;

					const parent = findParentNode((node) => node.type.name === 'div')(selection);

					if (!parent) return false;

					const div = parent.node;

					const attrs = {
						...div.attrs,
						...(top !== undefined && { borderTop: top }),
						...(bottom !== undefined && { borderBottom: bottom }),
						...(left !== undefined && { borderLeft: left }),
						...(right !== undefined && { borderRight: right }),
					};

					tr.setNodeMarkup(parent.pos, undefined, attrs);

					if (dispatch) dispatch(tr);
					return true;
				},
			setDivAttribute:
				(attribute, value) =>
				({ state, tr, dispatch }) => {
					const { selection } = state;

					const parent = findParentNode((node) => node.type.name === 'div')(selection);

					console.log('Parent', { parent, attribute, value });
					if (!parent) return false;

					const div = parent.node;

					const attrs = {
						...div.attrs,
						...(attribute !== undefined && { [attribute]: value }),
					};

					console.log('new div attributes', {
						existing: div.attrs,
						attrs,
						attribute,
						value,
					});
					tr.setNodeMarkup(parent.pos, undefined, attrs);

					if (dispatch) dispatch(tr);
					return true;
				},
		};
	},
});

export default CustomDiv;
